<template>
    <v-layout v-resize="onResize" column style="padding-top: 0px">
    <div class="container-fluid">
       <v-dialog v-model="dialogLoading" width="150px" height="auto">
                <v-card width="150px" height="150px" style="text-align: center">
                  <v-progress-circular
                    :size="70"
                    :width="7"
                    color="orange"
                    indeterminate
                    persistent
                    style="margin-top: 40px"
                  ></v-progress-circular>
                </v-card>
              </v-dialog>
      <div class="row" style="margin-top: 0px">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">Upload Huang Yi Data</div>
            <div class="card-body">
              <div class="container-fluid">
                <div class="row">
                  <v-file-input
                    v-model="file_upload"
                    show-size
                    accept=".csv"
                    placeholder="Upload Your File"
                    class="fileInput"
                    id="file"
                    ref="file"
                    @change="handleFileUpload"
                  >
                  </v-file-input>
                  <v-btn
                    style="margin-left: 10px; margin-right: 20px"
                    color="#3EB650"
                    dark
                    @click="onSubmit"
                    >Upload</v-btn
                  >
                  <v-btn
                    style="margin-right: 20px"
                    color="#FCC133"
                    dark
                    @click="onDownloadTemplate"
                    >Download Template</v-btn
                  >
                </div>
                <div class="row" style="margin-bottom: 20px">
                  <progress
                    max="100"
                    :value.prop="uploadPercentage"
                    style="width: 100%"
                  ></progress>
                </div>
                <div
                  class="row"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 20px;
                  "
                  width="100%"
                >
                  <v-btn
                    style="margin-left: 10px; margin-right: 20px"
                    color="#3EB650"
                    outlined
                    @click="onSaveData(1)"
                    >Insert All</v-btn
                  >
                  <v-btn
                    style="margin-right: 20px"
                    color="#EF5350"
                    outlined
                    @click="onSaveData(0)"
                    >Cancel All</v-btn
                  >
                </div>
                <div class="row"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 20px;
                  "
                  width="100%">
                  <!-- v-model="dataUploads" -->
                  <v-data-table
                    :headers="headers"
                    :items="data_table_upload"
                    :class="{mobile: isMobile}"
                    :hide-default-header="isMobile"
                    style="width: 100%"
                  ></v-data-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>

import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import axios from '@/axios'
export default {
    data: () => ({
        file_upload:null,
        file:null,
        dialogLoading:false,
        uploadPercentage: 0,
        dataUploads:'',
        headers: [
            { text: 'Name', align: 'start',value: 'Nama Indonesia',},
            { text: 'Chinese Name (Pinyin)', value: 'Nama Pin Yin' },
            { text: 'Chinese Name (Hanzi)', value: 'Nama Han Zi' },
            { text: 'Hobby', value: 'Hobi' },
        ],
        data_table_upload:[],
        filename_from_api:'',
        isMobile: false,
    }),
    methods:{
        handleFileUpload(){
            console.log(this.$refs.file.files);
          this.file = this.$refs.file.files;
        },
        onResize() {
            if (window.innerWidth < 769)
              this.isMobile = true;
            else{

              this.isMobile = false;
            }
        },
        onSubmit(){
            if(this.file!='' && this.file_upload!=null){
                let formData = new FormData();
                formData.append('file', this.file_upload);
                formData.append('type', 'HuangYi');

                axios({
                    method: 'post',
                    url: 'upload',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                    data: formData,
                    onUploadProgress: function( progressEvent ) {
                        this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                    },
                }).then(response => {
                     this.filename_from_api=response.data.filename;
                    console.log(response.data.lines);
                    this.data_table_upload=response.data.lines;
                    console.log('SUCCESS!!');
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }
        },
        onDownloadTemplate(){
            axios({
                method: 'post',
                url: 'download_template',
                responseType: 'blob', // important
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
                data:{
                    type: 'HuangYi'
                }
            }).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'TemplateTaoyu.csv');
                document.body.appendChild(link);
                link.click();
            }).catch(error => {
                console.log(error.response);
            });

        },
        onSaveData(nextTodo){
            let confirm_text=''
            if(nextTodo==1) confirm_text='Are you sure to process all of these data?';
            else confirm_text='Are you sure to cancel all of these data?';
            confirm(confirm_text) &&
            //this.dialogLoading=true
            axios({
                method: 'post',
                url: 'insert_csv',
                headers: {
                    Authorization: 'Bearer ' + this.$session.get('token'),
                },
                data: {
                    filename: this.filename_from_api,
                    next_to_do: nextTodo,
                    role: 'HuangYi'
                },
            }).then(function(response){
                if(response.data){
                    if(response.data.message === 'Gagal Jenis Kelamin Tidak Sama'){
                      Swal.fire({
                                  title:'Peringatan',
                                  icon :'warning',
                                  html: 'Jenis Kelamin tidak sesuai format yang benar (Wajib L/P)'
                          });
                    }else{
                      Swal.fire({
                                  title:'Peringatan',
                                  icon :'success',
                                  html: response.data.message+'.'+'<br>'+response.data.success+' sukses diinput .'+'<br>'+' '+response.data.duplicate+' '+'duplikat.'+' '+response.data.failed+' '+'gagal diinput.'
                          });
                    }

                }
            }).catch(function(error){
                    Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Data Gagal Disimpan'
                        });
            });
            this.$nextTick(() => {
                    this.file=''
                    this.data_table_upload=[]
                    this.file_upload=null
                    this.onSubmit()
                    this.dialogLoading=false

                })

        }
    }
}
</script>

<style>
.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
